import request from '@/utils/request'
import { pidToPNode } from '@/utils'

// 获取角色列表
export function getList(data) {
  const { page: current, limit: size, ...otherWhere } = data
  const wherePrefix = 'eq_sr.'
  const payload = {
    page: { current, size },
    where: Object.assign({}, ...Object.keys(otherWhere).map((key) => ({ [wherePrefix + key]: otherWhere[key] })))
  }
  payload.where["desc_sr.createTime"] = "1"

  return request.post('/sys/role/getPage', payload).then(({ data }) => {
    const { page, ...res } = data
    const { records, total, ...otherPage } = page
    const items = records.map(record => {
      const { id, roleName, menuIdList, description } = record
      const permission = pidToPNode(menuIdList)
      return {
        id, name: roleName, permissionList: permission, remark: description
      }
    })
    return { data: { ...res, data: { items, total } } }
  })
}


// 创建角色信息
export function createOne(data) {
  const { remark, name, id, permissionList } = data
  const payload = {
    id,
    description: remark,
    roleName: name,
    menuIdList: permissionList
  }
  return request.post('/sys/role/save', payload)
}

// 更新角色信息
export function updateOne(data) {
  const { remark, name, id, permissionList } = data
  const payload = {
    id,
    description: remark,
    roleName: name,
    menuIdList: permissionList
  }
  return request.post('/sys/role/update', payload)
}

// 删除角色信息
export function deleteOne(data) {
  const url = '/sys/role/delete/' + data.id
  return request.get(url)
}
